import { DtoHasApi } from './dto-has-api.model';
import { Api } from 'src/core/decorators/dto/api.decorator';

@Api('api/app/user')
export class UserPhotoDto extends DtoHasApi {
  userId: string = '';
  photo: string;
}
